module.exports = __webpack_public_path__ + "static/81-564f70d863810453e7eb9545f9f966ba.png";